var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tr',{staticClass:"row-header"},[_c('b-td',{staticClass:"text-right font-weight-bold bg-gradient",attrs:{"colspan":_vm.colspan}},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_vm._l((_vm.totalsByMonth),function(total,idx){return _c('b-td',{key:idx,staticClass:"font-weight-bold bg-gradient text-right"},[_vm._v(" "+_vm._s(total)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }